import { GATrackingEvent } from '~shared/modules/ga-tracking/models';
import { GATrackingEventType } from '../../constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { OptimizelyMethodTypeEnum } from '~shared/modules/application-event/constants';

export class GATrackingOptimizelyExperimentNewEvent implements GATrackingEvent {
  constructor(private method: OptimizelyMethodTypeEnum,
              private event: string,
              private action: string,
              private label: string,
              private category?: string) {}
  getEventType(): GATrackingEventType {
    return GATrackingEventType.OptimizelyActivateExperiment;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event,
      label: this.label,
      gtmCustom: {
        action: this.action,
        method: this.method
      },
      category: this.category,
    };
  }
}
